export const SKILLS = [
  'Python Programming',
  'Web Development',
  'Teaching',
  'Communication',
  'Leadership',
  'Organization',
  'Research',
  'Writing',
  'Event Planning',
  'Social Media',
  'Marketing',
  'Project Management',
  'Healthcare Knowledge',
  'Environmental Knowledge',
  'Business Knowledge',
  'Digital Media',
  'Problem Solving',
  'Creativity',
  'First Aid',
  'Patient Care'
] as const;

export const INTERESTS = [
  'Technology',
  'Education',
  'Healthcare',
  'Environment',
  'Business',
  'Arts',
  'Community Service',
  'Social Impact',
  'Research',
  'Innovation'
] as const;

export const LOCATION_PREFERENCES = [
  { value: 'In Person', label: 'In Person' },
  { value: 'Remote', label: 'Remote' },
  { value: 'Hybrid', label: 'Hybrid' },
  { value: 'Any', label: 'Any' }
] as const;

export const LOCATION_TYPES = [
  { value: 'in_person', label: 'In Person' },
  { value: 'remote', label: 'Remote' },
  { value: 'hybrid', label: 'Hybrid' }
] as const;

export const INDUSTRIES = [
  { value: 'Technology', label: 'Technology' },
  { value: 'Entertainment', label: 'Entertainment' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Business', label: 'Business' },
  { value: 'Environment', label: 'Environment' }
] as const;

export const CITIES = [
  { value: 'Toronto', label: 'Toronto' },
  { value: 'Markham', label: 'Markham' },
  { value: 'Scarborough', label: 'Scarborough' },
  { value: 'Mississauga', label: 'Mississauga' },
  { value: 'Oshawa', label: 'Oshawa' },
  { value: 'North York', label: 'North York' }
] as const;

export type Skill = typeof SKILLS[number];
export type Interest = typeof INTERESTS[number];
export type LocationPreference = typeof LOCATION_PREFERENCES[number]['value'];
export type LocationType = typeof LOCATION_TYPES[number]['value'];
export type Industry = typeof INDUSTRIES[number]['value'];
export type City = typeof CITIES[number]['value'];
